import { render, staticRenderFns } from "./TradingViewLoginModal.vue?vue&type=template&id=c448f858&scoped=true"
import script from "./TradingViewLoginModal.vue?vue&type=script&lang=js"
export * from "./TradingViewLoginModal.vue?vue&type=script&lang=js"
import style0 from "./TradingViewLoginModal.vue?vue&type=style&index=0&id=c448f858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c448f858",
  null
  
)

export default component.exports